import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";

import wizardStyle from "assets/jss/material-dashboard-pro-react/components/wizardStyle.jsx";

import axios from "axios";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import {setSessionOnLogin} from "../../assets/helpers/loginHelper";
import { getUserGroups } from "../../assets/helpers/utilityHelper";
import { API_ROOT } from 'api-config';

class Wizard extends React.Component {
  constructor(props) {
    super(props);
    var width;
    if (this.props.steps.length === 1) {
      width = "100%";
    } else {
      if (window.innerWidth < 600) {
        if (this.props.steps.length !== 3) {
          width = "50%";
        } else {
          width = 100 / 3 + "%";
        }
      } else {
        if (this.props.steps.length === 2) {
          width = "50%";
        } else {
          width = 100 / 3 + "%";
        }
      }
    }
    this.state = {
      currentStep: 0,
      color: this.props.color,
      nextButton: this.props.steps.length > 1 ? true : false,
      previousButton: false,
      finishButton: this.props.steps.length === 1 ? true : false,
      width: width,
      movingTabStyle: {
        transition: "transform 0s"
      },
      allStates: [],
      finishButtonDisabled: false,
      tempUsername: '',
      tempPassword: '',
      acceptCreditCards: false
    };
    this.navigationStepChange = this.navigationStepChange.bind(this);
    this.refreshAnimation = this.refreshAnimation.bind(this);
    this.previousButtonClick = this.previousButtonClick.bind(this);
    this.previousButtonClick = this.previousButtonClick.bind(this);
    this.finishButtonClick = this.finishButtonClick.bind(this);
    this.updateWidth = this.updateWidth.bind(this);
  }
  componentDidMount() {
    this.refreshAnimation(0);
    window.addEventListener("resize", this.updateWidth);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }
  updateWidth() {
    this.refreshAnimation(this.state.currentStep);
  }
  navigationStepChange(key) {
    if (this.props.steps) {
      var validationState = true;
      if (key > this.state.currentStep) {
        for (var i = this.state.currentStep; i < key; i++) {
          if (this[this.props.steps[i].stepId].sendState !== undefined) {
            this.setState({
              allStates: [
                ...this.state.allStates,
                {
                  [this.props.steps[i].stepId]: this[
                    this.props.steps[i].stepId
                  ].sendState()
                }
              ]
            });
          }
          if (
            this[this.props.steps[i].stepId].isValidated !== undefined &&
            this[this.props.steps[i].stepId].isValidated() === false
          ) {
            validationState = false;
            break;
          }
        }
      }
      if (validationState) {
        this.setState({
          currentStep: key,
          nextButton: this.props.steps.length > key + 1 ? true : false,
          previousButton: key > 0 ? true : false,
          finishButton: this.props.steps.length === key + 1 ? true : false
        });
        this.refreshAnimation(key);
      }
    }
  }
  nextButtonClick() {
    if (
      (this.props.validate &&
        ((this[this.props.steps[this.state.currentStep].stepId].isValidated !==
          undefined &&
          this[
            this.props.steps[this.state.currentStep].stepId
          ].isValidated()) ||
          this[this.props.steps[this.state.currentStep].stepId].isValidated ===
            undefined)) ||
      this.props.validate === undefined
    ) {
      if (
        this[this.props.steps[this.state.currentStep].stepId].sendState !==
        undefined
      ) {
        this.setState({
          allStates: [
            ...this.state.allStates,
            {
              [this.props.steps[this.state.currentStep].stepId]: this[
                this.props.steps[this.state.currentStep].stepId
              ].sendState()
            }
          ]
        });
      }
      var key = this.state.currentStep + 1;
      this.setState({
        currentStep: key,
        nextButton: this.props.steps.length > key + 1 ? true : false,
        previousButton: key > 0 ? true : false,
        finishButton: this.props.steps.length === key + 1 ? true : false
      });
      this.refreshAnimation(key);
    } else {
      alert("Please complete all required fields before proceeding, and make sure the correct type of value is in " +
            "each required field. Fields with issues are marked in red.")
    }
  }
  previousButtonClick() {
    if (
      this[this.props.steps[this.state.currentStep].stepId].sendState !==
      undefined
    ) {
      this.setState({
        allStates: [
          ...this.state.allStates,
          {
            [this.props.steps[this.state.currentStep].stepId]: this[
              this.props.steps[this.state.currentStep].stepId
            ].sendState()
          }
        ]
      });
    }
    var key = this.state.currentStep - 1;
    if (key >= 0) {
      this.setState({
        currentStep: key,
        nextButton: this.props.steps.length > key + 1 ? true : false,
        previousButton: key > 0 ? true : false,
        finishButton: this.props.steps.length === key + 1 ? true : false
      });
      this.refreshAnimation(key);
    }
  }
  finishButtonClick() {
    if (
      this.props.validate &&
      ((this[this.props.steps[this.state.currentStep].stepId].isValidated !==
        undefined &&
        this[this.props.steps[this.state.currentStep].stepId].isValidated()) ||
        this[this.props.steps[this.state.currentStep].stepId].isValidated ===
          undefined) &&
      this.props.finishButtonClick !== undefined
    ) {
      this.props.finishButtonClick();
    } else {

      this.setState({
        finishButtonDisabled: true
      })
      this[this.props.steps[this.state.currentStep].stepId].updateRegistrationMessage('registering...')


      //loop through the array in reverse
      //using reverse on the array cause the allStates state to also flip, which I don't want to do
      var submitArray = [];
      submitArray['userInfo'] = '';
      submitArray['address'] = '';
      submitArray['options'] = '';
      submitArray['provider'] = '';
      submitArray['plan'] = '';
      submitArray['payment'] = '';
      submitArray['agreement'] = '';
      var i;
      for (i = this.state.allStates.length - 1; i >= 0; i--) {

        if (this.state.allStates[i]) {
          var objectKey = Object.keys(this.state.allStates[i])[0]
          if (submitArray[objectKey] === '') {
            submitArray[objectKey] = this.state.allStates[i][objectKey]
          }
        }
      }
      this.setState({
        tempUsername: submitArray['userInfo']['email'],
        tempPassword: submitArray['userInfo']['password1'],
        acceptCreditCards: submitArray['options']['acceptCreditCards'],
        tempUserId: submitArray['userInfo']['userId'],
        tempUserType: submitArray['userInfo']['userType']
      })

      const submitData = {
        userInfo: JSON.stringify(submitArray['userInfo']),
        address: JSON.stringify(submitArray['address']),
        options: JSON.stringify(submitArray['options']),
        provider: JSON.stringify(submitArray['provider']),
        plan: JSON.stringify(submitArray['plan']),
        payment: JSON.stringify(submitArray['payment']),
        agreement: JSON.stringify(submitArray['agreement'])
      }
      axios.post(`${API_ROOT}/register/`, submitData, { headers: getApiHeaders() })
        .then(res => this.handleRegistrationResponse(res));
    }
  }

  handleRegistrationResponse(res) {
    var updateMessage = '';
    var updateHeader = '';
    var showLoginLink = '';
    var showSuccessIcon = false;
    var loginUser = false;
    var postLoginMessage = ''
    if (res.data.message.status === 'success') {
      updateHeader = "Registration complete.";
      updateMessage = "Well done. You have successfully completed the registration process. We'll take you to your account in 5 seconds, or click the link below to log in."
      showLoginLink = true;
      showSuccessIcon = true;
      loginUser = true;
      postLoginMessage = res.data.message.postLoginMessage
    } else {
      this.setState({
        finishButtonDisabled: false
      })
      updateHeader = 'We need you to fix something.'
      updateMessage = "There was an issue creating your account: ";
      updateMessage += res.data.message.status;
      updateMessage += ". ";
      updateMessage += "Please fix this issue and try again. ";
      updateMessage += "If you fix the issue and are still not able to register, please contact support.";
      showLoginLink = false;
    }
    this[this.props.steps[this.state.currentStep].stepId].updateRegistrationMessage(updateHeader, updateMessage, showLoginLink, showSuccessIcon);
    if (loginUser) {
      if (this.state.tempUserId) { // if a userId is set, this means the user is just changing account types. We just need to load new user type and refresh
        const userGroups = JSON.stringify([this.state.tempUserType])
        sessionStorage.setItem('userGroups', userGroups);
        const redirectTo = this.getRedirectTo(postLoginMessage)
        window.location = redirectTo;
      } else {
        const loginData = {
          username: this.state.tempUsername,
          password: this.state.tempPassword
        }

        axios.post(`${API_ROOT}/auth/login/`, loginData, { headers: getApiHeaders() })
          .then(res => this.handleLoginResponse(res.data, postLoginMessage));
      }
    }
  }

  handleLoginResponse(res, postLoginMessage) {
    this.setState({
      tempUsername: '',
      tempPassword: ''
    })
    if (!res.message) { // if there is not an error
      setSessionOnLogin(res)
      const redirectTo = this.getRedirectTo(postLoginMessage)
      window.location = redirectTo;
    }
  }

  getRedirectTo(postLoginMessage) {
    const userGroups = getUserGroups()
    var redirectTo = '/?postLoginMessage='+postLoginMessage;
    if (userGroups.indexOf('organization') >= 0) {
      redirectTo += '&showQuickstart=true';
    }
    if (this.state.acceptCreditCards) {
      redirectTo += '&showCreditCardProcessorSignup=true';
    }
    return redirectTo
  }

  refreshAnimation(index) {
    var total = this.props.steps.length;
    var li_width = 100 / total;
    var total_steps = this.props.steps.length;
    var move_distance = this.refs.wizard.children[0].offsetWidth / total_steps;
    var index_temp = index;
    var vertical_level = 0;

    var mobile_device = window.innerWidth < 600 && total > 3;

    if (mobile_device) {
      move_distance = this.refs.wizard.children[0].offsetWidth / 2;
      index_temp = index % 2;
      li_width = 50;
    }

    this.setState({ width: li_width + "%" });

    var step_width = move_distance;
    move_distance = move_distance * index_temp;

    var current = index + 1;

    if (current === 1 || (mobile_device === true && index % 2 === 0)) {
      move_distance -= 8;
    } else if (
      current === total_steps ||
      (mobile_device === true && index % 2 === 1)
    ) {
      move_distance += 8;
    }

    if (mobile_device) {
      vertical_level = parseInt(index / 2, 10);
      vertical_level = vertical_level * 38;
    }
    var movingTabStyle = {
      width: step_width,
      transform:
        "translate3d(" + move_distance + "px, " + vertical_level + "px, 0)",
      transition: "all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)"
    };
    this.setState({ movingTabStyle: movingTabStyle });
  }
  render() {
    const { classes, title, subtitle, color, steps } = this.props;
    return (
      <div className={classes.wizardContainer} ref="wizard">
        <Card className={classes.card}>
          <div className={classes.wizardHeader}>
            <h3 id="wizardFormTitle" className={classes.title}>{title}</h3>
            <h5 className={classes.subtitle}>{subtitle}</h5>
          </div>
          <div className={classes.wizardNavigation}>
            <ul className={classes.nav}>
              {steps.map((prop, key) => {
                return (
                  <li
                    className={classes.steps}
                    key={key}
                    style={{ width: this.state.width }}
                  >
                    <span
                      className={classes.stepsAnchor}
                      //onClick={() => this.navigationStepChange(key)}
                    >
                      {prop.stepName}
                    </span>
                  </li>
                );
              })}
            </ul>
            <div
              className={classes.movingTab + " " + classes[color]}
              style={this.state.movingTabStyle}
            >
              {steps[this.state.currentStep].stepName}
            </div>
          </div>
          <div className={classes.content}>
            {steps.map((prop, key) => {
              const stepContentClasses = cx({
                [classes.stepContentActive]: this.state.currentStep === key,
                [classes.stepContent]: this.state.currentStep !== key
              });
              return (
                <div className={stepContentClasses} key={key}>
                  <prop.stepComponent
                    innerRef={node => (this[prop.stepId] = node)}
                    allStates={this.state.allStates}
                  />
                </div>
              );
            })}
          </div>
          <div className={classes.footer}>
            <div className={classes.left}>
              {this.state.previousButton ? (
                <Button
                  className={this.props.previousButtonClasses}
                  onClick={() => this.previousButtonClick()}
                >
                  {this.props.previousButtonText}
                </Button>
              ) : null}
            </div>
            <div className={classes.right}>
              {this.state.nextButton ? (
                <Button
                  color="cirrusBlue"
                  className={this.props.nextButtonClasses}
                  onClick={() => this.nextButtonClick()}
                  id="nextButton"
                >
                  {this.props.nextButtonText}
                </Button>
              ) : null}
              {this.state.finishButton ? (
                <Button
                  color="cirrusBlue"
                  className={this.finishButtonClasses}
                  disabled={this.state.finishButtonDisabled}
                  onClick={() => this.finishButtonClick()}
                  id="finishButton"
                >
                  {this.props.finishButtonText}
                </Button>
              ) : null}
            </div>
            <div className={classes.clearfix} />
          </div>
        </Card>
      </div>
    );
  }
}

Wizard.defaultProps = {
  color: "cirrusBlue",
  title: "Here should go your title",
  subtitle: "And this would be your subtitle",
  previousButtonText: "Previous",
  previousButtonClasses: "",
  nextButtonClasses: "",
  nextButtonText: "Next",
  finishButtonClasses: "",
  finishButtonText: "Finish"
};

Wizard.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepName: PropTypes.string.isRequired,
      stepComponent: PropTypes.func.isRequired,
      stepId: PropTypes.string.isRequired
    })
  ).isRequired,
  color: PropTypes.oneOf([
    "primary",
    "warning",
    "danger",
    "success",
    "info",
    "cirrusBlue"
  ]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  previousButtonClasses: PropTypes.string,
  previousButtonText: PropTypes.string,
  nextButtonClasses: PropTypes.string,
  nextButtonText: PropTypes.string,
  finishButtonClasses: PropTypes.string,
  finishButtonText: PropTypes.string,
  finishButtonClick: PropTypes.func,
  validate: PropTypes.bool
};

export default withStyles(wizardStyle)(Wizard);
